// extracted by mini-css-extract-plugin
module.exports = {"CSS_BREAKPOINT_LARGE":"1200px","CSS_BREAKPOINT_MEDIUM":"540px","CSS_BREAKPOINT_SMALL":"375px","CarouselCard":"CarouselCard_CarouselCard__3R54k"};